import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'createJS',
  gameConfig: dataConfig,
  title: [
    {
      text: 'W oknie programu Paint umieść ikony narzędzi i opcję, których można użyć podczas wykonywania obrazka. Zastosuj metodę <i>złap, przesuń i&nbsp;upuść</i>.',
      audio: 'games/page013_game4/audio/z13c4.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page013_game4/audio/z13c4-brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
